var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{staticClass:"flex flex-center fit"},[_c('div',{staticClass:"notfound__frame"},[_vm._v("指定されたURLは存在しません。")])])
}
var staticRenderFns = []

export { render, staticRenderFns }